var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5701 6.95631L14.0379 6.43556L12.9964 5.5L12.5286 6.02075L10.4536 8.33068L9.46961 7.4033L8.9602 6.9232L8 7.94204L8.50942 8.42214L9.5178 9.37248L9.50708 9.38441L10.0059 9.8325L10.0158 9.84184L10.5252 10.3219L10.5369 10.3095L10.5486 10.32L10.9856 9.83348L11.4854 9.3031L11.4728 9.29115L13.5701 6.95631Z",
    fill: "#9B51E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.5V3.5H6.5V6.5V7H6H3V12.5H10V11.5H11V12.5V13.5H10H3H2V12.5V5.5L5 2.5H6.5H10H11V3.5V5.5H10ZM5.41421 3.5H5.5V6H3V5.91421L5.41421 3.5Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileOn);
export default __webpack_public_path__ + "static/media/icon-file-on.2a6d83f80377aaf1af233a62fd3c3191.svg";
export { ForwardRef as ReactComponent };